import './App.css';
import Login from './components/Login';
import OtpVerification from './components/Otpverification';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import { SocketProvider } from "./context/SocketContext";
import NotificationListener from "./NotificationListener";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import Sidebar from "./ClientComponents/Components/DashboardLayout";
import Dashboard from "./ClientComponents/Dashboard/Dashboard";
import Documents from "./ClientComponents/Documents";
import Reviews from "./ClientComponents/Reviews";
import Bills from "./ClientComponents/Bills";
import AppointmentsPage from "./ClientComponents/Appointments/Appointment";
import ClientPrescriptions from './ClientComponents/ClientPrescriptions';

import './Styles/global.css';
import PatientRegister from './components/PatientRegister';
 
 
function App() {
  const userId =
    localStorage.getItem("adminId") ||
    localStorage.getItem("userId") ||
    localStorage.getItem("id");
 

 
function ProtectedRoute({ children }) {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/admin" />;
}
 
 
  return (
    <BrowserRouter>
      {/* LISTEN FOR SOCKET EVENTS */}
      <NotificationListener />
 
      {/* REQUIRED FOR TOASTS */}
      <ToastContainer position="top-right" autoClose={5000} />
      <SocketProvider userId={userId}>
        <Routes>
          <Route path='/' element={<Login />} />
          <Route path='/otp-verify' element={<OtpVerification />} />
 
          <Route path="/client" element={<Sidebar />}>
            <Route index element={<Navigate to="dashboard" />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="documents" element={<Documents />} />
            <Route path="appointment" element={<AppointmentsPage />} />
            <Route path="reviews" element={<Reviews />} />
            <Route path="bills" element={<Bills />} />
            <Route path="prescriptions" element={<ClientPrescriptions />} />
          </Route>
          <Route path="/register" element={<PatientRegister />} />
        </Routes>
 
      </SocketProvider>
    </BrowserRouter>
  );
}
 
export default App;